import React from 'react';
import ReactDOM from 'react-dom/client';
import EVSimulator from './ev-sim_v2_2.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <EVSimulator />
  </React.StrictMode>
);